export const RENT_SAVE = 'RENT_SAVE';
export const RENT_CLEAR = 'RENT_CLEAR';

export const RENT_STATISTIC = 'RENT_STATISTIC';
export const RENT_STATISTIC_REJECT_REASON = 'RENT_STATISTIC_REJECT_REASON';

export const RENT_EXIT_CLEAR = 'RENT_EXIT_CLEAR';
export const RENT_EXIT_SAVE = 'RENT_EXIT_SAVE';
export const RENT_EXIT_UPDATE = 'RENT_EXIT_UPDATE';

export const RENT_CONTINUE_CLEAR = 'RENT_CONTINUE_CLEAR';
export const RENT_CONTINUE_SAVE = 'RENT_CONTINUE_SAVE';
export const RENT_CONTINUE_UPDATE = 'RENT_CONTINUE_UPDATE';

export const RESERVE_SAVE = 'RESERVE_SAVE';
export const INSTRUMENT_LIST = 'INSTRUMENT_LIST';
export const INSTRUMENT_SET_STOCK = 'INSTRUMENT_SET_STOCK';

export const INSTRUMENT_SUBTYPES = 'INSTRUMENT_SUBTYPES';
export const RENT_LIST = 'RENT_LIST';
export const RENT_TABLE_LIST = 'RENT_TABLE_LIST';
export const RENT_ACT_STATUSES = 'RENT_ACT_STATUSES';
export const RENT_TABLE_LIST_HAS_NEXT = 'RENT_TABLE_LIST_HAS_NEXT';

export const ADD_RESERVES_TO_LIST = 'ADD_RESERVES_TO_LIST';

export const ADD_RENTS_TO_LIST = 'ADD_RENTS_TO_LIST';
export const ADD_RENTS_ARCHIVE_TO_LIST = 'ADD_RENTS_ARCHIVE_TO_LIST';
export const RESERVE_LIST = 'RESERVE_LIST';
export const RENT_ARCHIVE_LIST = 'RENT_ARCHIVE_LIST';
export const RESERVE_UPDATE = 'RESERVE_UPDATE';
export const RENT_ACCRUAL_LIST = 'RENT_ACCRUAL_LIST';
export const RENT_UPDATE = 'RENT_UPDATE';
export const INSTRUMENT_CATEGORIES = 'INSTRUMENT_CATEGORIES';
export const INSTRUMENT_ADD_LIST = 'INSTRUMENT_ADD_LIST';
